import { render, staticRenderFns } from "./ProductCongratulations.vue?vue&type=template&id=4064a96b&scoped=true"
import script from "./ProductCongratulations.vue?vue&type=script&lang=js"
export * from "./ProductCongratulations.vue?vue&type=script&lang=js"
import style0 from "./ProductCongratulations.vue?vue&type=style&index=0&id=4064a96b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4064a96b",
  null
  
)

export default component.exports